import {defineStore} from 'pinia'
import {jwtDecode} from 'jwt-decode'
import {useCartStore} from '~/store/cart'
import {AUTH_TOKEN_COOKIE_NAME, PRICE_TOKEN_COOKIE_NAME, ROLE_NAMES} from '~/utils/userUtils'
import {useConfigStore} from '~/store/config'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    authenticated: false,
    token: null,
    priceToken: null,
    user: {
      id: null,
      initials: null,
      fullname: null,
      firstname: null,
      lastname: null,
      email: null,
      avatar: null,
      hasCard: null,
      phone: null,
      country: null,
      hasBillingAddress: null,
      roles: null
    }
  }),
  actions: {
    async login(token) {
      if (!token) {
        token = null
        await this.logout()
        return
      }
      const tokenDecoded = jwtDecode(token)
      this.authenticated = true
      this.token = token
      this.user = getUserDataFromToken(tokenDecoded)

      const cookieOptions = {
        path: '/',
        expires: new Date(tokenDecoded.exp * 1000)
      }
      const authCookie = useCookie(AUTH_TOKEN_COOKIE_NAME, cookieOptions)
      authCookie.value = token

      const cartStore = useCartStore()
      await cartStore.reloadCartItems()
    },
    async logout() {
      this.$reset()
      const cookieOptions = {
        path: '/'
      }
      const authCookie = useCookie(AUTH_TOKEN_COOKIE_NAME, cookieOptions)
      authCookie.value = null

      const cartStore = useCartStore()
      await cartStore.clearCart(true)
      await cartStore.reloadCartItems()

      const configStore = useConfigStore()
      await configStore.load()
    },
    setPriceToken(token) {
      this.priceToken = token

      if (token) {
        const tokenDecoded = jwtDecode(token)

        const cookieOptions = {
          path: '/',
          expires: new Date(tokenDecoded.exp * 1000)
        }
        const priceTokenCookie = useCookie(PRICE_TOKEN_COOKIE_NAME, cookieOptions)
        priceTokenCookie.value = token
      } else {
        const cookieOptions = {
          path: '/'
        }
        const priceTokenCookie = useCookie(PRICE_TOKEN_COOKIE_NAME, cookieOptions)
        priceTokenCookie.value = null
      }
    }
  },
  getters: {
    isAuth: (state) => state.token !== null,
    currentUser: (state) => state.user,
    currentToken: (state) => state.token,
    currentUserRole: (state) => {
      if (!state.user || !state.user.roles || state.user.roles.length === 0) {
        return 'user'
      }
      return state.user.roles[0]
    },
    currentUserRoleName: (state) => {
      let currentRole = 'user'

      if (!state.user || !state.user.roles || state.user.roles.length === 0) {
        currentRole = 'user'
      } else {
        currentRole = state.user.roles[0]
      }

      return ROLE_NAMES[currentRole]
    },
    hasPriceToken: (state) => state.priceToken !== null
  }
})
